import { MULTICALL2_ADDRESS } from '@emberswap/emberswap-sdk2/dist/constants'
import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { zeroAddress } from 'viem'
import { Address } from 'wagmi'
import { getContract } from 'wagmi/actions'

import { multicall2Abi } from '../constants/abis/multicall2'


export const getMulticall3ContractConfig = (chainId: ChainId) => ({
  address: chainId ? MULTICALL2_ADDRESS[chainId] : zeroAddress as Address,
  abi: multicall2Abi,
})

/**
 * @param {ChainId}chainId 
 * @return {Contract | Null}
 */
export function useMulticall3Contract(chainId: ChainId) {
  return getContract({
    ...getMulticall3ContractConfig(chainId),
  })
}
